import {Theme} from "../../stem-core/src/ui/style/Theme.js";
import {Color, enhance} from "../../stem-core/src/ui/Color.js";
import {Link} from "../../stem-core/src/ui/primitives/Link.jsx";
import {BlinkLinkStyle} from "../../core/ui/LinkButton.jsx";


export function initializeTheme(merchantThemeConstants={}) {
    const ThemeConstants = {
        WALLET_0: "#F8FBFB",
        WALLET_1: "#E8F0F2",
        WALLET_2: "#D2E2E5",
        WALLET_3: "#BBD4D8",
        WALLET_4: "#A5C6CB",
        WALLET_5: "#8EB8BE",
        WALLET_6: "#78AAB2",
        WALLET_7: "#619CA5",
        WALLET_8: "#4B8E98",
        WALLET_9: "#34808B",
        WALLET_10: "#1E727E",
        WALLET_11: "#086472",
        WALLET_12: "#085B68",
        WALLET_13: "#07525E",
        WALLET_14: "#064953",
        WALLET_15: "#064049",
        WALLET_16: "#05373F",
        WALLET_17: "#042E34",
        WALLET_18: "#03252A",
        WALLET_19: "#031C20",
        WALLET_20: "#021315",
        WALLET_21: "#010506",

        MERCHANT_1: "#A0A0A0",
        MERCHANT_2: "#6C6C6C",
        MERCHANT_3: "#3F3F3F",
        MERCHANT_4: "#232323",
        MERCHANT_5: "#151515",

        WHITE: "#FFFFFF", // TODO @cleanup nobody means props.WHITE

        FONT_SIZE_SMALL: 12,
        FONT_SIZE_NORMAL: 14,
        FONT_SIZE_LARGE: 16,
        FONT_SIZE_TITLE: 21,
        FONT_SIZE_VERIFICATION_CODE: 40,

        FONT_WEIGHT_LIGHT: "lighter",
        FONT_WEIGHT_REGULAR: "normal",
        FONT_WEIGHT_BOLD: "bold",

        TEXT_PRIMARY_COLOR: "#232529",
        TEXT_SECONDARY_COLOR: "#545F69",

        ERROR_COLOR: "#FF4848",
        SUCCESS_COLOR: "#11BA87",

        LINK_COLOR: "#0080FF",

        DEFAULT_DISABLED_OPACITY: 0.6, // TODO @cleanup move into STEM, use everywhere

        FIT_CONTENT: ["fit-content", "-moz-fit-content"],

        // ------------------- INPUTS & BUTTONS --------------------
        BASE_BORDER_RADIUS: 6,
        INPUT_USE_PLACEHOLDER_AS_LABEL: false,
        INPUT_BACKGROUND_COLOR: "",
        INPUT_BORDER_RADIUS: props => props.BASE_BORDER_RADIUS,
        INPUT_BORDER_COLOR: Color.addOpacity("#545F69", 0.24).toString(),
        INPUT_BORDER_ACTIVE_COLOR: Color.addOpacity("#545F69", 0.5).toString(),
        INPUT_TEXT_COLOR: "#444F59",
        BASE_INPUT_BACKGROUND: "#FDFFFE",
        BASE_INPUT_PLACEHOLDER_COLOR: "rgba(102,102,102,.72)",
        BASE_INPUT_NOT_EDITABLE_LABEL_COLOR: props => props.MERCHANT_2,

        BUTTON_PRIMARY_COLOR: props => props.WHITE,
        BUTTON_PRIMARY_BACKGROUND: props => props.WALLET_11,
        BUTTON_PRIMARY_BORDER_COLOR: "transparent",
        BUTTON_PRIMARY_INACTIVE_TEXT_COLOR: "rgba(255,255,255,0.5)",
        BUTTON_PRIMARY_TEXT_SHADOW: "0 1px 2px rgba(6,73,83,.12)",
        BUTTON_PRIMARY_SHADOW: "0 2px 6px 0 rgba(6, 73, 83, 0.24)",
        BUTTON_PRIMARY_DISABLED_TEXT_SHADOW: "0 1px 2px rgba(6,73,83,.12)",
        BUTTON_PRIMARY_DISABLED_BACKGROUND: props => props.WALLET_9,
        BUTTON_PRIMARY_DISABLED_COLOR: props => props.WALLET_4,
        BUTTON_PRIMARY_HOVER_BACKGROUND: props => props.WALLET_13,
        BUTTON_PRIMARY_HOVER_SHADOW: "0 2px 10px 0 rgba(6,73,83,.48)",

        BUTTON_SECONDARY_BACKGROUND: props => props.WHITE,
        BUTTON_SECONDARY_COLOR: props => props.WALLET_7,
        BUTTON_SECONDARY_SHADOW: props => "0 2px 8px rgba(6,73,83,.12), inset 0 0 0 1px " + props.WALLET_11,
        BUTTON_SECONDARY_HOVER_SHADOW: props => "0 2px 8px rgba(6,73,83,.24), inset 0 0 0 1px " + props.WALLET_11,
        BUTTON_SECONDARY_BORDER_COLOR: Color.addOpacity("#535558", 0.3).toString(),
        BUTTON_SECONDARY_INACTIVE_TEXT_COLOR: "rgba(83,85,88,0.5)",

        BUTTON_TERTIARY_TEXT_COLOR: "linear-gradient(180deg, #125C67 0%, #0F4851 100%)",
        BUTTON_TERTIARY_INACTIVE_TEXT_COLOR: "rgba(108,108,108,0.5)",

        ACTIVE_BUTTON_FONT_SIZE: 18,
        ACTIVE_BUTTON_INACTIVE_BORDER: "none",
        ACTIVE_BUTTON_ACTIVE_BORDER: "none",
        ACTIVE_BUTTON_INACTIVE_COLOR: props => props.WALLET_9,
        ACTIVE_BUTTON_INACTIVE_BACKGROUND: props => props.WALLET_3,
        ACTIVE_BUTTON_INACTIVE_HOVER_BACKGROUND: props => props.WALLET_4,
        ACTIVE_BUTTON_COLOR: props => props.WHITE,
        ACTIVE_BUTTON_BACKGROUND: props => props.WALLET_11,

        RADIO_BUTTON_PRIMARY_BACKGROUND: "linear-gradient(180deg, #125761 0%, #0F4851 100%)",
        RADIO_BUTTON_PRIMARY_BORDER_COLOR: "linear-gradient(180deg, #125761 0%, #0F4851 100%)",
        RADIO_BUTTON_PRIMARY_TEXT_COLOR: props => props.WHITE,
        RADIO_BUTTON_SECONDARY_BACKGROUND: "transparent",
        RADIO_BUTTON_SECONDARY_BORDER_COLOR: Color.addOpacity("#545F69", 0.24).toString(),
        RADIO_BUTTON_SECONDARY_TEXT_COLOR: "#767F87",

        SOCIAL_BUTTON_SHADOW: "0 5px 8px 0 rgba(50, 50, 93, 0.11), 0 2px 4px 0 rgba(0, 0, 0, 0.08)",
        SOCIAL_BUTTON_HOVER_SHADOW: "0 4px 7px 0 rgba(50, 50, 93, 0.22), 0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        SOCIAL_BUTTON_FACEBOOK_COLOR: props => props.WHITE,
        SOCIAL_BUTTON_FACEBOOK_BACKGROUND: "#3B5A9A",
        SOCIAL_BUTTON_GOOGLE_COLOR: "rgba(0, 0, 0, 0.72)",
        SOCIAL_BUTTON_GOOGLE_BACKGROUND: props => props.WHITE,
        SOCIAL_BUTTON_LINKEDIN_COLOR: props => props.WHITE,
        SOCIAL_BUTTON_LINKEDIN_BACKGROUND: "#0077B5",
        SOCIAL_BUTTON_TWITTER_COLOR: props => props.WHITE,
        SOCIAL_BUTTON_TWITTER_BACKGROUND: "#1da1f2",

        TOGGLE_BACKGROUND: props => props.WALLET_2,
        TOGGLE_COLOR: props => props.WALLET_11,
        TOGGLE_SHADOW: "0 1px 1px 0 rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12), 0 1px 3px 0 rgba(0,0,0,.2)",
        TOGGLE_DISABLED_BACKGROUND: props => props.WALLET_6,

        CHECKBOX_SIZE: "1.14em",
        CHECKBOX_BORDER_RADIUS: 2,
        CHECKBOX_BORDER_COLOR: props => props.WALLET_11,
        CHECKBOX_ENABLED_BACKGROUND_COLOR: props => props.WALLET_11,
        CHECKBOX_CHECKMARK_COLOR: props => props.WHITE,

        DROPDOWN_ITEM_BORDER: "rgba(27,126,140,.24)",
        DROPDOWN_ITEM_HOVER_BACKGROUND: "rgba(2, 92, 150, 0.06)",
        DROPDOWN_PLACEHOLDER_COLOR: "rgba(102,102,102,.72)",

        RADIO_SIZE: 16,
        RADIO_COLOR: "#545F69",

        RADIO_BUTTON_BORDER_RADIUS: 4,
        RADIO_BUTTON_PADDING: 12,
        RADIO_BUTTON_FLEX: 1, // TODO @cleanup this shouldn't be a constant

        // ---------------------- GENERAL ------------------------
        APP_BACKGROUND: "#FAFDFD",
        NAV_MOBILE_COLOR: props => props.WHITE,
        NAV_MOBILE_SHADOW: "0 8px 16px -8px rgba(0, 0, 0, 0.15), 0 13px 27px -5px rgba(50, 50, 93, 0.12)",
        NAVBAR_BOX_SHADOW: "0 12px 12px -6px rgba(0, 0, 0, 0.12)",
        NAVBAR_BACKGROUND: props => props.WALLET_11,
        NAVBAR_CENTER_ITEM_ACTIVE: props => props.WHITE,
        NAVBAR_CENTER_ITEM_INACTIVE: props => props.WALLET_3,

        MODAL_BACKGROUND: props => props.WALLET_0,
        MODAL_SHADOW: "0 0 6px 0 rgba(0,0,0,.12), 0 8px 16px -8px rgba(0,0,0,.15), 0 13px 27px -5px rgba(50,50,93,.12)",

        SPINNER_COLOR: props => props.WALLET_8,
        DASHBOARD_SCRIM_BACKGROUND: "rgba(255,255,255,.84)", // For all dashboards

        BASE_CARD_SHADOW: "0 6px 12px -6px rgba(0,0,0,.12), 0 10px 20px -4px rgba(0,0,0,0.12)",
        BASE_CARD_BACKGROUND: props => props.WALLET_0,
        BASE_CARD_TITLE_COLOR: props => props.WALLET_11,
        BASE_CARD_WIDTH: 480,
        BASE_CARD_MAX_WIDTH: 480,

        CARD_HEADER_TEXT_COLOR: "#005A64", // TODO merge with BUTTON_COLOR into PRIMARY
        CARD_HEADER_BACKGROUND_COLOR: "#F3F8F7",
        LOGO_CARD_SHADOW: "0 6px 10px -6px rgba(0, 0, 0, 0.3), 0 9px 18px -4px rgba(50, 50, 93, 0.25)",
        LOGO_CARD_CONTENT_BACKGROUND: props => props.WHITE,
        PANEL_BUTTON_LOGO_FILL: props => props.WHITE,

        DIVIDER_TEXT_COLOR: "rgba(0, 0, 0, 0.48)",
        DIVIDER_LINE_COLOR: "rgba(84, 95, 105, 0.12)",

        TOAST_TEXT_COLOR: props => props.WHITE,
        TOAST_BACKGROUND: "rgba(0,0,0,.84)",
        TOAST_ACTION_COLOR: "#FFFA6E",

        // ----------------------- TABLE & FAKE TABLE -------------------
        TABLE_HEADER_TEXT_COLOR: props => props.CARD_HEADER_TEXT_COLOR,
        TABLE_HEADER_BACKGROUND_COLOR: props => props.CARD_HEADER_BACKGROUND_COLOR,
        TABLE_HEADER_BACKGROUND_ALTERNATE: "#F5F5F5",
        TABLE_ENTRY_TEXT_COLOR: props => props.MERCHANT_3,
        TABLE_BORDER_COLOR: props => props.WALLET_2,
        TABLE_CHEVRON: props => props.MERCHANT_1,

        EXPANSION_PANEL_HEADING_COLOR: props => props.MERCHANT_2,
        EXPANSION_PANEL_PARAGRAPH_COLOR: props => props.MERCHANT_4,
        EXPANSION_PANEL_BUTTON_CLOSE: props => props.ERROR_COLOR,
        EXPANSION_PANEL_BUTTON_RENEW: props => props.LINK_COLOR,

        // ------------------------- MISC ----------------------------
        SETTINGS_LABEL_COLOR: props => props.MERCHANT_4,
        USER_DASHBOARD_DESCRIPTION_COLOR: props => props.MERCHANT_2, // TODO make this a generic DASHBOARD_DESCRIPTION_COLOR, and replace in all dashboards
        GENERAL_LINE_HEIGHT: "1.5",

        // Wallet specific
        WALLET_BALANCE_COLOR: props => props.WHITE,
        WALLET_GRADIENT_BACKGROUND: "linear-gradient(60deg, #085B68, #064953)",
    };

    Theme.setProperties(ThemeConstants);

    // TODO move this somewhere else
    Theme.register(Link, BlinkLinkStyle);

    const autoenhance = color => enhance(color, (Color.isLight(color) || Color.isBlack(color)) ? 0.03 : -0.15, (Color.isLight(color) || Color.isBlack(color)) ? 0.1 : 0.2);

    // TODO remove the MERCHANT_ in the setting file
    const MerchantDefaultConstants = {
        // --------------- TYPOGRAPHY ---------------------
        MERCHANT_FONT_FAMILY: props => props.FONT_FAMILY_DEFAULT,

        MERCHANT_FONT_SIZE_SMALL: props => props.FONT_SIZE_SMALL,
        MERCHANT_FONT_SIZE_NORMAL: props => props.FONT_SIZE_NORMAL,
        MERCHANT_FONT_SIZE_LARGE: props => props.FONT_SIZE_LARGE,
        MERCHANT_FONT_SIZE_TITLE: props => props.FONT_SIZE_TITLE,
        MERCHANT_FONT_SIZE_VERIFICATION_CODE: props => props.FONT_SIZE_VERIFICATION_CODE,

        MERCHANT_FONT_WEIGHT_LIGHT: props => props.FONT_WEIGHT_LIGHT,
        MERCHANT_FONT_WEIGHT_REGULAR: props => props.FONT_WEIGHT_REGULAR,
        MERCHANT_FONT_WEIGHT_BOLD: props => props.FONT_WEIGHT_BOLD,

        MERCHANT_TEXT_PRIMARY_COLOR: props => props.TEXT_PRIMARY_COLOR,
        MERCHANT_TEXT_SECONDARY_COLOR: props => props.TEXT_SECONDARY_COLOR,
        MERCHANT_TEXT_LINK_COLOR: props => props.LINK_COLOR, // TODO @rename to MERCHANT_LINK_COLOR

        // -------------- INPUTS & BUTTONS ---------------
        // TODO @cleanup rename this BUTTON_INPUT_TOAST crap into MERCHANT_BASE_BORDER_RADIUS
        MERCHANT_BUTTON_INPUT_TOAST_BORDER_RADIUS: props => props.BASE_BORDER_RADIUS,
        MERCHANT_RADIO_BUTTON_BORDER_RADIUS: props => props.RADIO_BUTTON_BORDER_RADIUS,

        MERCHANT_BUTTON_PRIMARY_STYLE: {}, // TODO @cleanup @rename to MERCHANT_BUTTON_STYLE
        MERCHANT_BUTTON_PRIMARY_BACKGROUND: "linear-gradient(180deg, #125C67 0%, #0F4851 100%)",
        MERCHANT_BUTTON_PRIMARY_BORDER_COLOR: props => props.BUTTON_PRIMARY_BORDER_COLOR,
        MERCHANT_BUTTON_PRIMARY_TEXT_COLOR: props => props.BUTTON_PRIMARY_COLOR,
        MERCHANT_BUTTON_PRIMARY_INACTIVE_TEXT_COLOR: props => props.BUTTON_PRIMARY_INACTIVE_TEXT_COLOR,

        MERCHANT_BUTTON_SECONDARY_COLOR: props => props.MERCHANT_2,
        MERCHANT_BUTTON_SECONDARY_HOVER: "#000000",
        MERCHANT_BUTTON_SECONDARY_BACKGROUND: "transparent",
        MERCHANT_BUTTON_SECONDARY_BORDER_COLOR: props => props.BUTTON_SECONDARY_BORDER_COLOR,
        MERCHANT_BUTTON_SECONDARY_TEXT_COLOR: "#535558",
        MERCHANT_BUTTON_SECONDARY_INACTIVE_TEXT_COLOR: props => props.BUTTON_SECONDARY_INACTIVE_TEXT_COLOR,

        MERCHANT_BUTTON_TERTIARY_TEXT_COLOR: props => props.BUTTON_TERTIARY_TEXT_COLOR,
        MERCHANT_BUTTON_TERTIARY_INACTIVE_TEXT_COLOR: props => props.BUTTON_TERTIARY_INACTIVE_TEXT_COLOR,

        MERCHANT_INPUT_STYLE: {},
        MERCHANT_USE_INPUT_PLACEHOLDER_INSTEAD_OF_LABEL: props => props.INPUT_USE_PLACEHOLDER_AS_LABEL, // TODO @rename to MERCHANT_INPUT_USE_PLACEHOLDER_AS_LABEL
        MERCHANT_INPUT_CONTAINER: {},
        MERCHANT_INPUT_BACKGROUND: props => props.BASE_INPUT_BACKGROUND,
        MERCHANT_INPUT_BORDER_COLOR: props => props.INPUT_BORDER_COLOR,
        MERCHANT_INPUT_BORDER_ACTIVE_COLOR: props => props.INPUT_BORDER_ACTIVE_COLOR,
        MERCHANT_INPUT_TEXT_COLOR: props => props.INPUT_TEXT_COLOR,
        MERCHANT_INPUT_PLACEHOLDER_COLOR: props => props.BASE_INPUT_PLACEHOLDER_COLOR,

        MERCHANT_RADIO_BUTTON_PRIMARY_BACKGROUND: props => props.RADIO_BUTTON_PRIMARY_BACKGROUND,
        MERCHANT_RADIO_BUTTON_PRIMARY_BORDER_COLOR: props => props.RADIO_BUTTON_PRIMARY_BORDER_COLOR,
        MERCHANT_RADIO_BUTTON_PRIMARY_TEXT_COLOR: props => props.RADIO_BUTTON_PRIMARY_TEXT_COLOR,
        MERCHANT_RADIO_BUTTON_SECONDARY_BACKGROUND: props => props.RADIO_BUTTON_SECONDARY_BACKGROUND,
        MERCHANT_RADIO_BUTTON_SECONDARY_BORDER_COLOR: props => props.RADIO_BUTTON_SECONDARY_BORDER_COLOR,
        MERCHANT_RADIO_BUTTON_SECONDARY_TEXT_COLOR: props => props.RADIO_BUTTON_SECONDARY_TEXT_COLOR,

        MERCHANT_CHECKBOX_SIZE: props => props.CHECKBOX_SIZE,
        MERCHANT_CHECKBOX_BORDER_RADIUS: props => props.CHECKBOX_BORDER_RADIUS,
        MERCHANT_CHECKBOX_BORDER_COLOR: props => props.CHECKBOX_BORDER_COLOR,
        MERCHANT_CHECKBOX_ENABLED_BACKGROUND_COLOR: props => props.CHECKBOX_ENABLED_BACKGROUND_COLOR,
        MERCHANT_CHECKBOX_CHECKMARK_COLOR: props => props.CHECKBOX_CHECKMARK_COLOR,

        MERCHANT_POPUP_BACKGROUND: props => props.WHITE,
        MERCHANT_POPUP_BORDER: null,
        MERCHANT_POPUP_SHADOW: "0 2px 8px 5px rgba(0,0,0,.1), 0 5px 27px -5px rgba(0,0,0,.37)",

        // -------------- GENERAL ----------------------
        MERCHANT_SPINNER_BACKGROUND: "rgba(255,255,255,.84)",
        MERCHANT_SPINNER_COLOR: "#125C67", // This is also used in the icons in the benefits section.
        MERCHANT_SCRIM_BACKGROUND: "rgba(0,0,0,.5)",

        MERCHANT_FRAME_BACKGROUND: "#FBFDFD",
        MERCHANT_FRAME_BORDER: null,
        MERCHANT_FRAME_HEADER_BACKGROUND: "#F3F7F8",
        MERCHANT_FRAME_CLOSE_BUTTON_COLOR: "#242424",
        MERCHANT_FRAME_CLOSE_BUTTON_SIZE: 28,
        MERCHANT_FRAME_BORDER_COLOR: "rgba(84, 95, 105, 0.18)",
        MERCHANT_FRAME_BORDER_RADIUS: "10px",
        MERCHANT_FRAME_HEADER_BORDER_COLOR: Color.addOpacity("#545F69", 0.12).toString(),

        MERCHANT_CARD_BACKGROUND: props => props.WHITE,
        MERCHANT_CARD_BOX_SHADOW: "0 12px 12px 0px rgba(0, 0, 0, 0.12)",
        MERCHANT_CARD_BORDER_COLOR: "#E3E3E3",

        MERCHANT_FOOTER_TEXT: "#545F69",
        MERCHANT_FOOTER_LOGO: "#545F69",

        // TODO @rename to ..._COLOR
        MERCHANT_SUCCESS: props => props.SUCCESS_COLOR,
        MERCHANT_ERROR: props => props.ERROR_COLOR,

        MERCHANT_USER_DASHBOARD_TAB_STYLE: {
            background: "#E0E0E0",
            textDecoration: "none !important",
        },
        MERCHANT_USER_DASHBOARD_ACTIVE_TAB_STYLE: props => ({
            background: props.WHITE,
        }),

        MERCHANT_TITLE_STYLE: {},

        MERCHANT_BUTTON_PRIMARY_BACKGROUND_HOVER: props => autoenhance(props.MERCHANT_BUTTON_PRIMARY_BACKGROUND),
        MERCHANT_BUTTON_PRIMARY_BORDER_COLOR_HOVER: props => autoenhance(props.MERCHANT_BUTTON_PRIMARY_BORDER_COLOR),
        MERCHANT_BUTTON_SECONDARY_BACKGROUND_HOVER: props => autoenhance(props.MERCHANT_BUTTON_SECONDARY_BACKGROUND),
        MERCHANT_BUTTON_SECONDARY_BORDER_COLOR_HOVER: props => autoenhance(props.MERCHANT_BUTTON_SECONDARY_BORDER_COLOR),
        MERCHANT_BUTTON_TERTIARY_TEXT_COLOR_HOVER: props => autoenhance(props.MERCHANT_BUTTON_TERTIARY_TEXT_COLOR),
        MERCHANT_RADIO_BUTTON_PRIMARY_BACKGROUND_HOVER: props => autoenhance(props.MERCHANT_RADIO_BUTTON_PRIMARY_BACKGROUND),
        MERCHANT_BUTTON_PRIMARY_TEXT_COLOR_HOVER: props => props.MERCHANT_BUTTON_PRIMARY_TEXT_COLOR,
        MERCHANT_RADIO_BUTTON_PRIMARY_BORDER_COLOR_HOVER: props => autoenhance(props.MERCHANT_RADIO_BUTTON_PRIMARY_BORDER_COLOR),
        MERCHANT_RADIO_BUTTON_SECONDARY_BACKGROUND_HOVER: props => autoenhance(props.MERCHANT_RADIO_BUTTON_SECONDARY_BACKGROUND),
        MERCHANT_RADIO_BUTTON_SECONDARY_BORDER_COLOR_HOVER: props => autoenhance(props.MERCHANT_RADIO_BUTTON_SECONDARY_BORDER_COLOR),
        MERCHANT_INPUT_BACKGROUND_HOVER: props => autoenhance(props.MERCHANT_INPUT_BACKGROUND),
        MERCHANT_TEXT_LINK_COLOR_HOVER: props => autoenhance(props.MERCHANT_TEXT_LINK_COLOR),
        MERCHANT_ERROR_HOVER: props => autoenhance(props.MERCHANT_ERROR),
    };

    Theme.setProperties({...MerchantDefaultConstants, ...merchantThemeConstants});
}
